import { useMutation } from "@apollo/client";
import { CreatePremiumServiceInterestForm } from "components/forms";
import {
  getCreatePremiumServiceInterestInitialValues,
} from "components/forms/premium-service-interest/schema";
import { Modal } from "components/layouts";
import { useFormik } from "formik";
import { FC } from "react";
import toast from "react-hot-toast";
import { CREATE_PREMIUM_SERVICE_INTEREST } from "./apollo";

interface CreatePremiumServiceInterestContainerProps {
  open: boolean;
  setOpen: (val: boolean) => void;
  refetch?: () => void;
}

const CreatePremiumServiceInterestContainer: FC<
  CreatePremiumServiceInterestContainerProps
> = ({ open, setOpen, refetch }) => {
  const [createPremiumServiceInterest] = useMutation(
    CREATE_PREMIUM_SERVICE_INTEREST,
  );

  const form = useFormik({
    initialValues: getCreatePremiumServiceInterestInitialValues(),
    enableReinitialize: true,
    onSubmit: async (values) => {

      const generateRAT = values.interestInfo.generateRAT
      await createPremiumServiceInterest({
        variables: {
          ...values.interestInfo,
          ...(generateRAT && {
            ratDetails: {
              assignee: values.assigneeInfo?.assignee?._id,
              ...values.extraInfo,
            }
          }),
        },
      }).then(({ data }) => {
        if (data?.createPremiumServiceInterest?._id) {
          toast(
            JSON.stringify({
              type: "success",
              title: "Expression of Interest Created Successfully",
            }),
          );
          refetch?.();
          form.resetForm();
          setOpen(false);
        } else {
          toast(
            JSON.stringify({
              type: "error",
              title: "Could not create Expression of Interest",
            }),
          );
        }
      });
    },
    onReset: () => {
      setOpen(false);
    },
  });

  return (
    <Modal
      open={open}
      setOpen={setOpen}
      size="4xl"
      title="Create Expression of Interest"
      description="Provide customer details to register an expression of interest and optionally generate a Readiness Acceptance Test"
      hideActions={true}
    >
      <CreatePremiumServiceInterestForm form={form} />
    </Modal>
  );
};

export default CreatePremiumServiceInterestContainer;
